import styled from 'styled-components'
import {airBlue} from '@modifi/colors'

export const StyledComment = styled.div`
  margin-top: 5px;
  width: 250px;
  word-break: break-word;
`

export const TitleWrapper = styled.div`
  display: flex;
  align-items: flex-start;

  > strong {
    margin-right: 10px;
  }

  > button {
    margin: -15px 0 0 5px;
  }
`

export const NameTag = styled.div`
  border-radius: 15px;
  background-color: ${({color}) => color || airBlue};
  padding: 0 15px;
  margin: 5px 5px 0 0;
  display: inline-block;
`
